import React from 'react';
import {
  createFrontendPlugin,
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGitlabSlugAvailable } from './utils/annotations';
import { dependencyViewerApiRef } from './api/DependencyViewerApi';
import { DependencyViewerClient } from './api/DependencyViewerClient';

const dependencyViewerEntityContent = EntityContentBlueprint.make({
  name: 'dependency-viewer',
  params: {
    path: '/dependencies',
    title: 'Dependencies',
    filter: isGitlabSlugAvailable,
    loader: async () =>
      import('./components/DependencyViewerPage').then(m =>
        compatWrapper(React.createElement(m.DependencyViewerPage)),
      ),
  },
});

const dependencyViewerApi = ApiBlueprint.make({
  name: 'dependency-viewer',
  params: defineParams =>
    defineParams({
      api: dependencyViewerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DependencyViewerClient({ discoveryApi, fetchApi }),
    }),
});

const dependencyViewerPlugin = createFrontendPlugin({
  pluginId: 'dependency-viewer',
  extensions: [dependencyViewerEntityContent, dependencyViewerApi],
});

export default dependencyViewerPlugin;
